module.exports = __webpack_public_path__ + "img/horizontal_4_5_8011.fe2b613b.png";